<form nz-form [formGroup]="form">
  <nz-form-item>
    <nz-form-control nzHasFeedback nzErrorTip="Informe o nível de log.">
      <nz-form-label>Nível</nz-form-label>
      <nz-select formControlName="level" nzPlaceHolder="Selecione o nível">
        <nz-option nzLabel="Debug" nzValue="debug"></nz-option>
        <nz-option nzLabel="Info" nzValue="info"></nz-option>
        <nz-option nzLabel="Warn" nzValue="warn"></nz-option>
        <nz-option nzLabel="Error" nzValue="error"></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-control nzHasFeedback nzErrorTip="Informe um TTL válido.">
      <nz-form-label>Duração (segundos)</nz-form-label>
      <input nz-input formControlName="ttl" type="number" min="1" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-control>
      <label nz-checkbox formControlName="http">Habilitar logs HTTP</label>
    </nz-form-control>
  </nz-form-item>

  <div class="modal-actions">
    <button nz-button nzType="default" type="button" (click)="closeModal()">Cancelar</button>
    <button nz-button nzType="primary" type="button" [nzLoading]="isSubmitting" (click)="submit()">Habilitar logs</button>
  </div>
</form>

<nz-alert
  *ngIf="enableLogsResponse?.ok"
  nzType="success"
  nzShowIcon
  nzMessage="Logs habilitados com sucesso"
  [nzDescription]="successDescriptionTemplate"
  style="margin-top: 16px"></nz-alert>

<ng-template #successDescriptionTemplate>
  <p>
    <strong>Nível aplicado:</strong>
    {{ enableLogsResponse?.applied?.logLevel }}
  </p>
  <p>
    <strong>HTTP Habilitado?:</strong>
    {{ enableLogsResponse?.applied?.isHttpAccessLogEnabled ? 'Sim' : 'Não' }}
  </p>
  <p>
    <strong>APP Habilitado?:</strong>
    {{ enableLogsResponse?.applied?.isAppLogEnabled ? 'Sim' : 'Não' }}
  </p>
  <p>
    <strong>Duração (segundos):</strong>
    {{ enableLogsResponse?.ttlSeconds }} segundos
  </p>
  <p>
    <strong>Escopo:</strong>
    {{ enableLogsResponse?.scope?.service }} / {{ enableLogsResponse?.scope?.environment }}
  </p>
  <pre>{{ enableLogsResponse | json }}</pre>
</ng-template>
